import { defineWebformElementMapper } from '../defineWebformElementMapper'

/**
 * Appends a time to the min/max attribute.
 */
function mapMinMax(
  minMax: string | undefined,
  suffix: string,
): string | undefined {
  if (minMax && !minMax.includes('T')) {
    return minMax + 'T' + suffix
  }

  return minMax
}

export default defineWebformElementMapper(
  ['WebformElementDatetime'],
  (item) => {
    return {
      $formkit: 'datetime-local',
      min: mapMinMax(item.element.dateDateMin, '00:00'),
      max: mapMinMax(item.element.dateDateMax, '23:59'),
    }
  },
)
